var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.717773 7.57117C0.717773 3.47461 4.02579 0.153687 8.10644 0.153687H21.406C25.4867 0.153687 28.7947 3.47461 28.7947 7.57117V20.9226C28.7947 25.0192 25.4867 28.3401 21.406 28.3401H8.10644C4.02579 28.3401 0.717773 25.0192 0.717773 20.9226V7.57117Z",
    fill: "#E00030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.0576V14.168M15 17.2784H15.0078M13.9207 7.08542L7.50966 18.1325C7.15406 18.7452 6.97627 19.0516 7.00254 19.303C7.02547 19.5224 7.14065 19.7217 7.31942 19.8513C7.52439 20 7.87925 20 8.58898 20H21.411C22.1207 20 22.4756 20 22.6806 19.8513C22.8594 19.7217 22.9745 19.5224 22.9975 19.303C23.0237 19.0516 22.8459 18.7452 22.4903 18.1325L16.0793 7.08542C15.725 6.47488 15.5478 6.1696 15.3167 6.06708C15.1151 5.97764 14.8849 5.97764 14.6833 6.06708C14.4522 6.1696 14.275 6.47488 13.9207 7.08542Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.d3cd3d616cbaf00afde957d1cf7fe0a0.svg";
export { ForwardRef as ReactComponent };